import { consumptionAPI } from "./clients";

const END_POINT = "/dashboards";
/**
 * Endpoint to get the list of all DataSource available
 */
const getDashboardList = type => {
  let endpoint = type ? `${END_POINT}?type=${type}` : END_POINT;
  return consumptionAPI.get(endpoint);
};

/**
 * Creates a dashboard with the specified data
 * @param {Object} data
 */
const createDashboard = data => {
  return consumptionAPI.post(END_POINT, data);
};

/**
 * Updates current dashboard with the specified data
 * @param {Object} data
 */
const updateDashboard = ({ payload, dashboard_id }) => {
  return consumptionAPI.post(`${END_POINT}/${dashboard_id}/update`, payload);
};

/**
 * Deletes a specified dashboard
 * @param {Number} dashboard_id
 */
const deleteDashboard = dashboard_id => {
  return consumptionAPI.post(`${END_POINT}/delete`, { dashboard_id });
};

/**
 * Duplicates a specified console with a new name
 * @param {Number} dashboard_id
 * @param {String} name
 * @param {String} description
 */
const duplicateDashboard = (dashboard_id, name, description) => {
  return consumptionAPI.post(`${END_POINT}/duplicate`, {
    dashboard_id,
    name,
    description,
  });
};

/**
 * Creates a shareable magic link
 * @param {String} dashboard_id
 */
const createMagicLink = dashboard_id => {
  return consumptionAPI.get(`/dashboards/${dashboard_id}/magic_link`);
};

/**
 * Disables the shareable magic link
 * @param {String} dashboard_id
 */
const disableMagicLink = dashboard_id => {
  return consumptionAPI.get(`/dashboards/${dashboard_id}/disable_magic_link`);
};

export {
  getDashboardList,
  createDashboard,
  updateDashboard,
  deleteDashboard,
  duplicateDashboard,
  createMagicLink,
  disableMagicLink,
};
